export default (ctx: any)=>( [
  {
    name: 'reports-visits',
    title: ctx.t('Visits'),
    value: 0
  },
  {
    name: 'reports-clicks',
    title: ctx.t('Clicks'),
    value: 0
  },
  {
    name: 'reports-conversionconfirm',
    title: ctx.t('Conversions'),
    value: 0
  },
  {
    name: 'reports-revenue',
    title: ctx.t('Revenue'),
    value: 0
  },
  {
    name: 'reports-cost',
    title: ctx.t('Cost'),
    value: 0
  },
  {
    name: 'reports-profit',
    title: ctx.t('Profit'),
    value: 0
  },
  {
    name: 'reports-roi',
    title: ctx.t('ROI'),
    value: 0
  }
])